<template>
    <breeze-authenticated-layout>
        <template #header>
            <div class="flex justify-between items-center">
                <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                    Dashboard Big Box
                </h2>
                <div class="flex items-center space-x-3">
                    <button
                        @click="open = true"
                        class="
                            py-1
                            px-2
                            bg-indigo-500
                            text-white
                            rounded
                            focus:outline-none
                        "
                    >
                        Add Item
                    </button>
                </div>
            </div>
        </template>

        <div class="py-12">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-sm sm:rounded-lg">
                    <div class="p-6 bg-white border-b border-gray-200">
                        <div class="flex flex-col">
                            <div
                                class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8"
                            >
                                <div
                                    class="
                                        py-2
                                        align-middle
                                        inline-block
                                        min-w-full
                                        sm:px-6
                                        lg:px-8
                                    "
                                >
                                    <div
                                        class="
                                            shadow
                                            overflow-hidden
                                            border-b border-gray-200
                                            sm:rounded-lg
                                        "
                                    >
                                        <table
                                            class="
                                                min-w-full
                                                divide-y divide-gray-200
                                            "
                                        >
                                            <thead class="bg-gray-50">
                                                <tr>
                                                                                                        <th
                                                        scope="col"
                                                        class="
                                                            px-6
                                                            py-3
                                                            text-left text-xs
                                                            font-medium
                                                            text-gray-500
                                                            uppercase
                                                            tracking-wider
                                                        "
                                                    >
                                                        #
                                                    </th>
                                                    <th
                                                        scope="col"
                                                        class="
                                                            relative
                                                            px-6
                                                            py-3
                                                        "
                                                    >
                                                        <span class="sr-only"
                                                        >Edit</span
                                                        >
                                                    </th>
                                                    <th
                                                        scope="col"
                                                        class="
                                                            px-6
                                                            py-3
                                                            text-left text-xs
                                                            font-medium
                                                            text-gray-500
                                                            uppercase
                                                            tracking-wider
                                                        "
                                                    >
                                                        Title
                                                    </th>
                                                    <th
                                                        scope="col"
                                                        class="
                                                            px-6
                                                            py-3
                                                            text-left text-xs
                                                            font-medium
                                                            text-gray-500
                                                            uppercase
                                                            tracking-wider
                                                        "
                                                    >
                                                        Slug
                                                    </th>
                                                    <th
                                                        scope="col"
                                                        class="
                                                            px-6
                                                            py-3
                                                            text-left text-xs
                                                            font-medium
                                                            text-gray-500
                                                            uppercase
                                                            tracking-wider
                                                        "
                                                    >
                                                        Plan
                                                    </th>
                                                    <th
                                                        scope="col"
                                                        class="
                                                            px-6
                                                            py-3
                                                            text-left text-xs
                                                            font-medium
                                                            text-gray-500
                                                            uppercase
                                                            tracking-wider
                                                        "
                                                    >
                                                        Order Number
                                                    </th>
                                                    <th
                                                        scope="col"
                                                        class="
                                                            px-6
                                                            py-3
                                                            text-left text-xs
                                                            font-medium
                                                            text-gray-500
                                                            uppercase
                                                            tracking-wider
                                                        "
                                                    >
                                                        Description
                                                    </th>
                                                    <th
                                                        scope="col"
                                                        class="
                                                            px-6
                                                            py-3
                                                            text-left text-xs
                                                            font-medium
                                                            text-gray-500
                                                            uppercase
                                                            tracking-wider
                                                        "
                                                    >
                                                        Introductions
                                                    </th>
                                                    <th
                                                        scope="col"
                                                        class="
                                                            px-6
                                                            py-3
                                                            text-left text-xs
                                                            font-medium
                                                            text-gray-500
                                                            uppercase
                                                            tracking-wider
                                                        "
                                                    >
                                                        Live
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody
                                                class="
                                                    bg-white
                                                    divide-y divide-gray-200
                                                "
                                            >
                                                <tr
                                                    v-for="(
                                                        item, index
                                                    ) in items"
                                                    :key="item.id"
                                                >
                                                    <td
                                                        class="
                                                            px-6
                                                            py-4
                                                            whitespace-nowrap
                                                        "
                                                    >
                                                        {{ index + 1 }}
                                                    </td>
                                                    <td
                                                        class="
                                                            px-6
                                                            py-4
                                                            whitespace-nowrap
                                                            text-right text-sm
                                                            font-medium
                                                        "
                                                    >
                                                        <button
                                                            @click="destroy(item)"
                                                            class="
                                                                text-red-400
                                                                hover:text-red-600
                                                                mx-3
                                                                focus:outline-none
                                                            "
                                                        >
                                                            Delete
                                                        </button>
                                                        <button
                                                            type="button"
                                                            @click="edit(item)"
                                                            class="
                                                                text-green-600
                                                                hover:text-green-900
                                                                mx-3
                                                                focus:outline-none
                                                            "
                                                        >
                                                            Edit
                                                        </button>
                                                    </td>
                                                    <td
                                                        class="
                                                            px-6
                                                            py-4
                                                            whitespace-nowrap
                                                        "
                                                    >
                                                        {{ item.title }}
                                                    </td>
                                                    <td
                                                        class="
                                                            px-6
                                                            py-4
                                                            whitespace-nowrap
                                                        "
                                                    >
                                                        {{ item.slug }}
                                                    </td>
                                                    <td
                                                        class="
                                                            px-6
                                                            py-4
                                                            whitespace-nowrap
                                                        "
                                                    >
                                                        {{ item.plan }}
                                                    </td>
                                                    <td
                                                        class="
                                                            px-6
                                                            py-4
                                                            whitespace-nowrap
                                                        "
                                                    >
                                                        {{ item.order_number }}
                                                    </td>
                                                    <td
                                                        class="
                                                            px-6
                                                            py-4
                                                        "
                                                    >
                                                        <div class="w-64 max-h-40 overflow-auto">
                                                            {{ item.info }}
                                                        </div>
                                                    </td>
                                                    <td
                                                        class="
                                                            px-6
                                                            py-4
                                                        "
                                                    >
                                                        <div class="w-64 max-h-40 overflow-auto">
                                                            {{ item.introductions }}
                                                        </div>
                                                    </td>
                                                    <td class="px-6 py-4">
                                                        <span
                                                            :class="{
                                                                'bg-green-100 text-green-800':
                                                                    item.live,
                                                                'bg-red-100 text-red-800':
                                                                    !item.live,
                                                            }"
                                                            class="
                                                                px-2
                                                                inline-flex
                                                                text-xs
                                                                leading-5
                                                                font-semibold
                                                                rounded-full
                                                            "
                                                        >
                                                            {{
                                                                item.live
                                                                    ? "Yes"
                                                                    : "No"
                                                            }}
                                                        </span>
                                                    </td>

                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </breeze-authenticated-layout>
    <dialog-model :show="open" @close="close">
        <template v-slot:title> {{ title }} </template>
        <template v-slot:content>
            <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
                    <div class="block w-full">
                        <label
                            for="title"
                            class="block text-sm font-medium text-gray-700"
                            >Title</label
                        >
                        <input
                            v-model="form.title"
                            type="text"
                            name="title"
                            id="title"
                            autocomplete="organization-title"
                            class="
                                mt-1
                                focus:ring-indigo-500 focus:border-indigo-500
                                block
                                w-full
                                shadow-sm
                                sm:text-sm
                                border-gray-300
                                rounded-md
                            "
                        />
                        <input-error
                            v-if="form.hasErrors"
                            :message="form.errors.dash_itmes_box.title"
                        />
                    </div>
                    <div class="block w-full">
                        <label
                            for="order_number"
                            class="block text-sm font-medium text-gray-700"
                        >Order Number</label
                        >
                        <input
                            v-model="form.order_number"
                            type="number"
                            name="order_number"
                            id="order_number"
                            class="
                                mt-1
                                focus:ring-indigo-500 focus:border-indigo-500
                                block
                                w-full
                                shadow-sm
                                sm:text-sm
                                border-gray-300
                                rounded-md
                            "
                        />
                        <input-error
                            v-if="form.hasErrors"
                            :message="form.errors.dash_itmes_box.order_number"
                        />
                    </div>
                    <div class="block w-full">
                        <label
                            for="section"
                            class="block text-sm font-medium text-gray-700"
                            >Section</label
                        >
                        <select
                            v-model="form.dashborads_id"
                            id="section"
                            name="section"
                            autocomplete="off"
                            class="
                                mt-1
                                block
                                w-full
                                py-2
                                px-3
                                border border-gray-300
                                bg-white
                                rounded-md
                                shadow-sm
                                focus:outline-none
                                focus:ring-indigo-500
                                focus:border-indigo-500
                                sm:text-sm
                            "
                        >
                            <option value="">Select section</option>
                            <option
                                :value="section.id"
                                :key="section.id"
                                v-for="section in sections"
                                v-html="section.title"
                            />
                        </select>
                        <input-error
                            v-if="form.hasErrors"
                            :message="form.errors.dash_itmes_box.dashborads_id"
                        />
                    </div>
                    <div class="block w-full">
                        <label
                            for="type"
                            class="block text-sm font-medium text-gray-700"
                            >Slug</label
                        >
                        <input
                            v-model="form.slug"
                            type="text"
                            name="slug"
                            id="slug"
                            class="
                                mt-1
                                focus:ring-indigo-500 focus:border-indigo-500
                                block
                                w-full
                                shadow-sm
                                sm:text-sm
                                border-gray-300
                                rounded-md
                            "
                        />
                        <input-error
                            v-if="form.hasErrors"
                            :message="form.errors.dash_itmes_box.slug"
                        />
                    </div>
                    <div class="block w-full">
                        <label
                            for="note"
                            class="block text-sm font-medium text-gray-700"
                        >Description</label
                        >
                        <textarea
                            v-model="form.info"
                            id="note"
                            name="note"
                            rows="3"
                            class="
                            shadow-sm
                            focus:ring-indigo-500 focus:border-indigo-500
                            mt-1
                            block
                            w-full
                            sm:text-sm
                            border border-gray-300
                            rounded-md
                        "
                        />
                        <input-error
                            v-if="form.hasErrors"
                            :message="form.errors.dash_itmes_box.info"
                        />
                    </div>
                    <div class="block w-full">
                        <label
                            for="introduction"
                            class="block text-sm font-medium text-gray-700"
                        >Introductions</label
                        >
                        <textarea
                            v-model="form.introductions"
                            id="introduction"
                            name="introduction"
                            rows="3"
                            class="
                            shadow-sm
                            focus:ring-indigo-500 focus:border-indigo-500
                            mt-1
                            block
                            w-full
                            sm:text-sm
                            border border-gray-300
                            rounded-md
                        "
                        />
                        <input-error
                            v-if="form.hasErrors"
                            :message="form.errors.dash_itmes_box.introductions"
                        />
                    </div>
                    <div class="block w-full">
                        <label
                            for="introduction_live"
                            class="block text-sm font-medium text-gray-700"
                        >Introductions Live</label
                        >
                        <select
                            v-model="form.introductions_live"
                            id="introduction_live"
                            name="introduction_live"
                            autocomplete="off"
                            class="
                            mt-1
                            block
                            w-full
                            py-2
                            px-3
                            border border-gray-300
                            bg-white
                            rounded-md
                            shadow-sm
                            focus:outline-none
                            focus:ring-indigo-500
                            focus:border-indigo-500
                            sm:text-sm
                        "
                        >
                            <option value="">Introductions is Live or not?</option>
                            <option value="1">Yes</option>
                            <option value="0">No</option>
                        </select>
                        <input-error
                            v-if="form.hasErrors"
                            :message="form.errors.dash_itmes_box.introductions_live"
                        />
                    </div>
                <div class="block w-full">
                    <label
                        for="live"
                        class="block text-sm font-medium text-gray-700"
                        >Live</label
                    >
                    <select
                        v-model="form.live"
                        id="live"
                        name="live"
                        autocomplete="off"
                        class="
                            mt-1
                            block
                            w-full
                            py-2
                            px-3
                            border border-gray-300
                            bg-white
                            rounded-md
                            shadow-sm
                            focus:outline-none
                            focus:ring-indigo-500
                            focus:border-indigo-500
                            sm:text-sm
                        "
                    >
                        <option value="">Dashboard itme is Live or not?</option>
                        <option value="1">Yes</option>
                        <option value="0">No</option>
                    </select>
                    <input-error
                        v-if="form.hasErrors"
                        :message="form.errors.dash_itmes_box.live"
                    />
                </div>
            </div>
        </template>
        <template v-slot:footer>
            <button
                type="button"
                class="
                    w-full
                    inline-flex
                    justify-center
                    rounded-md
                    border border-transparent
                    shadow-sm
                    px-4
                    py-2
                    bg-green-600
                    text-base
                    font-medium
                    text-white
                    hover:bg-green-700
                    focus:outline-none
                    focus:ring-2
                    focus:ring-offset-2
                    focus:ring-green-500
                    sm:ml-3 sm:w-auto sm:text-sm
                "
                @click="submit()"
            >
                Save
            </button>
            <button
                type="button"
                class="
                    mt-3
                    w-full
                    inline-flex
                    justify-center
                    rounded-md
                    border border-gray-300
                    shadow-sm
                    px-4
                    py-2
                    bg-white
                    text-base
                    font-medium
                    text-gray-700
                    hover:bg-gray-50
                    focus:outline-none
                    focus:ring-2
                    focus:ring-offset-2
                    focus:ring-indigo-500
                    sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm
                "
                @click="close()"
                ref="cancelButtonRef"
            >
                Cancel
            </button>
        </template>
    </dialog-model>
</template>
<script>
import BreezeAuthenticatedLayout from "@/Layouts/Authenticated";
import DialogModel from "@/Components/DialogModel";
import InputError from "@/Components/InputError";
import { useForm } from "@inertiajs/inertia-vue3";
export default {
    data() {
        return {
            open: false,
            editItemIndex: -1,
            form: useForm(
                {
                    id: "",
                    title: "",
                    order_number: "",
                    dashborads_id: "",
                    slug: "",
                    info: "",
                    introductions: "",
                    introductions_live: "",
                    live: "",
                },
                {
                    bag: "dash_itmes_box",
                }
            ),
        };
    },
    props: {
        items: Array,
        sections: Array,
    },
    computed: {
        title() {
            return this.editItemIndex > -1
                ? "Edit This Item"
                : "Add A new Item";
        },
    },
    methods: {
        close() {
            this.form.clearErrors();
            this.form.reset();
            this.open = false;
            this.editItemIndex = -1;
        },
        submit() {
            if (this.editItemIndex > -1) {
                // update request
                this.form.put(
                    route(`admin.user-dashboard-box.update`, this.form.id),
                    {
                        onSuccess: () => this.close(),
                        preserveScroll: true,
                    }
                );
            } else {
                // store request
                this.form.post(route(`admin.user-dashboard-box.store`), {
                    onSuccess: () => this.close(),
                    preserveScroll: true,
                });
            }
        },
        edit(item) {
            this.editItemIndex = this.items.indexOf(item);
            this.form.title = item.title;
            this.form.slug = item.slug;
            this.form.info = item.info;
            this.form.order_number = item.order_number;
            this.form.dashborads_id = item.dashborads_id;
            this.form.live = item.live ? 1 : 0;
            this.form.introductions = item.introductions;
            this.form.introductions_live = item.introductions_live;
            this.form.id = item.id;
            this.open = true;
        },
        destroy(item){
            if(confirm('Are you sure about deleting this item?')){
                this.$inertia.delete(route(
                    `admin.user-dashboard-box.destroy`,
                    {
                        user_dashboard_box: item.id,
                    }
                ))
            }
        },
    },
    components: {
        BreezeAuthenticatedLayout,
        DialogModel,
        InputError,
    },
};
</script>
